(function() {
  var __sections__ = {};
  (function() {
    for(var i = 0, s = document.getElementById('sections-script').getAttribute('data-sections').split(','); i < s.length; i++)
      __sections__[s[i]] = true;
    })();
    (function() {
  if (!__sections__["main-collection"]) return;
  try {
    
  const url = new URL(window.location.href);
  if (url.hash) {
    document.addEventListener(
      'DOMContentLoaded',
      () => {
        const card = document.getElementById(url.hash.slice(1));
        if (card) {
          card.scrollIntoView({ behavior: 'instant' });
        }
      },
      { once: true }
    );
  }

  } catch(e) { console.error(e); }
})();

(function() {
  if (!__sections__["sweb-catalog"] && !Shopify.designMode) return;
  try {
    
  document.querySelectorAll('[data-sweb-catalog]').forEach((root) => {
    if (root.dataset.ready) return; root.dataset.ready = 'true'; root.classList.add('is-enhanced');
    const form = root.querySelector('[data-sweb-refine]');
    form?.querySelectorAll('fieldset:last-of-type input').forEach((input) => input.addEventListener('change', () => form.querySelectorAll('fieldset:last-of-type input').forEach((other) => { if (other !== input) other.checked = false; })));
    form?.addEventListener('submit', (event) => {
      event.preventDefault(); const url = new URL(form.action, location.origin);
      const tags = [...form.querySelectorAll('input[name="filter.p.tag"]:checked')].map((field) => field.value);
      if (tags.length) url.pathname = `${url.pathname.replace(/\/$/, '')}/${tags.map(encodeURIComponent).join('+')}`;
      form.querySelectorAll('input[type="radio"]:checked').forEach((field) => url.searchParams.set(field.name, field.value));
      location.assign(url);
    });
    root.querySelector('[data-sweb-sort]')?.addEventListener('change', (event) => { const url = new URL(location.href); url.searchParams.set('sort_by', event.currentTarget.value); location.assign(url); });
    const grid = root.querySelector('[data-sweb-grid]'); const sentinel = root.querySelector('[data-sweb-sentinel]'); let next = root.querySelector('[data-sweb-next]'); let loading = false;
    if (!grid || !sentinel || !next) return;
    const load = async () => { if (loading || !next) return; loading = true; try { const url = new URL(next.href); url.searchParams.set('section_id', root.closest('.shopify-section').id.replace('shopify-section-','')); const response = await fetch(url); if (!response.ok) throw new Error(); const page = new DOMParser().parseFromString(await response.text(),'text/html'); page.querySelectorAll('[data-sweb-product]').forEach((card) => grid.append(card)); document.dispatchEvent(new Event('sweb:content')); const incoming = page.querySelector('[data-sweb-next]'); if (incoming) next.href = incoming.href; else { next = null; observer.disconnect(); root.querySelector('.sweb-load')?.remove(); } } catch { root.classList.remove('is-enhanced'); observer.disconnect(); } finally { loading = false; } };
    const observer = new IntersectionObserver((entries) => { if (entries[0].isIntersecting) load(); }, {rootMargin:'900px 0px'}); observer.observe(sentinel);
  });

  } catch(e) { console.error(e); }
})();
})();
